import { useRef, useState } from "react";
import Box from "@amzn/meridian/esm/components/box";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import stopTokens from "@amzn/meridian-tokens/base/icon/stop";
import cogTokens from "@amzn/meridian-tokens/base/icon/cog";
import vectorIcon from "../../../images/vector.svg";
import vectorIconActive from "../../../images/vector_active.svg";
import { VIEWS } from "../../../constants";
import { THEME_COLOR } from "../../../styles/colors";
import SettingsPopover from "../../settings/SettingsPopover";

const Footer = ({
  showEndButton,
  onEndClick,
  onSummariesClick,
  onSettingsClick,
  onOpenGeneral,
  activeView,
  showSettingsPopover,
  showSendToAll,
  sendToAllAttendees,
  onSendToAllAttendeesChange,
  showAgentToggle,
  canToggleAgents,
  enabledAgentIds,
  availableExtensions,
  onToggleAgent,
  onPopoverOpen,
  agentsLoading,
}) => {
  const settingsButtonRef = useRef(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const isPopoverOpen = popoverOpen && showSettingsPopover;

  const handleSettingsClick = () => {
    if (showSettingsPopover) {
      const opening = !isPopoverOpen;
      setPopoverOpen(opening);
      if (opening && onPopoverOpen) onPopoverOpen();
    } else {
      onSettingsClick();
    }
  };

  return (
    <Box width="362px" height="75px" backgroundColor={THEME_COLOR.LIGHT_LAVENDER}>
      <Row widths="fill" width="362px" alignmentHorizontal="center" alignmentVertical="center" height="100%" spacing="none">
        {showEndButton && (
          <Button onClick={onEndClick} type="link" size="large">
            <Column alignmentHorizontal="center" spacing="none">
              <div style={{ transform: "scale(0.80)" }}><Icon tokens={stopTokens} color="error" /></div>
              <Text type="b200" color="error">End</Text>
            </Column>
          </Button>
        )}
        <Button onClick={onSummariesClick} type="link" size="large">
          <Column alignmentHorizontal="center" spacing="none">
            <div style={{ transform: "scale(0.80)" }}><img src={activeView === VIEWS.SUMMARIES || activeView === VIEWS.SUMMARY_DETAIL ? vectorIconActive : vectorIcon} alt="Summaries" style={{ display: "block" }} /></div>
            <Theme tokens={{ textColorPrimary: THEME_COLOR.TEAL_GREEN }}>
              <Text type="b200" color={activeView === VIEWS.SUMMARIES || activeView === VIEWS.SUMMARY_DETAIL ? "primary" : "secondary"}>Summaries</Text>
            </Theme>
          </Column>
        </Button>
        <Button ref={settingsButtonRef} onClick={handleSettingsClick} type="link" size="large">
          <Column alignmentHorizontal="center" spacing="none">
            <div style={{ transform: "scale(0.80)" }}>
              <Icon tokens={cogTokens} color={isPopoverOpen || activeView === VIEWS.SETTINGS ? THEME_COLOR.TEAL_GREEN : "secondary"} />
            </div>
            <Theme tokens={{ textColorPrimary: THEME_COLOR.TEAL_GREEN }}>
              <Text type="b200" color={isPopoverOpen || activeView === VIEWS.SETTINGS ? "primary" : "secondary"}>Settings</Text>
            </Theme>
          </Column>
        </Button>
      </Row>
      {showSettingsPopover && (
        <SettingsPopover
          anchorNode={settingsButtonRef.current}
          open={isPopoverOpen}
          onClose={() => setPopoverOpen(false)}
          onOpenGeneral={onOpenGeneral}
          showSendToAll={showSendToAll}
          sendToAllAttendees={sendToAllAttendees}
          onSendToAllAttendeesChange={onSendToAllAttendeesChange}
          showAgentToggle={showAgentToggle}
          canToggleAgents={canToggleAgents}
          enabledAgentIds={enabledAgentIds}
          availableExtensions={availableExtensions}
          onToggleAgent={onToggleAgent}
          agentsLoading={agentsLoading}
        />
      )}
    </Box>
  );
};

export default Footer;
